import React, { Component } from 'react'
import '../styles/Reports.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIReportRequest from '../api/APIReportRequest'
import AlertMessage from '../widgets/AlertMessage'

class ReportSiteProvincial extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			regionId: user.region_id,
			disabled: props.disabled
		}
		this.getFarmerRegistrationSummaryByRegionId = this.getFarmerRegistrationSummaryByRegionId.bind(this)
		this.getFarmerClusteringSummaryPerProvinceByRegionId = this.getFarmerClusteringSummaryPerProvinceByRegionId.bind(this)
		this.getSWGSummaryPerProvinceByRegionId = this.getSWGSummaryPerProvinceByRegionId.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
	}

	getFarmerRegistrationSummaryByRegionId(regionId) {
		const ext = APIReportRequest.getFarmerRegistrationSummaryByRegionId(this.state.accessToken, regionId)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getFarmerClusteringSummaryPerProvinceByRegionId(rid) {
		const ext = APIReportRequest.getFarmerClusteringSummaryPerProvinceByRegionId(this.state.accessToken, rid)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results,
				showActivityIndicator: false
			})
		})
	}

	getSWGSummaryPerProvinceByRegionId(rid) {
		const ext = APIReportRequest.getSWGSummaryPerProvinceByRegionId(this.state.accessToken, rid)
		ext.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results.data,
				showActivityIndicator: false
			})
		})
	}

	handleFooterEvent(e) {
		if(this.state.data == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "No data for export. Please generate report."
			})
			return;
		}
		const dateObj = new Date()
		const month = dateObj.getMonth() + 1
		const date = month + "-" + dateObj.getDate() + "-" + dateObj.getFullYear()
		switch(this.state.typeId) {
			case 1:
				var filename = "RegisteredFarmersReport-" + date;
				break
			case 2:
				filename = "ClusterMembersReport-" + date;
				break
			case 3:
				filename = "CollectiveMarketingReport-" + date;
				break
			case 4:
				filename = "AEStepsTrackingReport-" + date;
				break
			case 5:
				filename = "SWGMembersReport-" + date;
				break
			case 6:
				filename = "OrganizationsReport-" + date;
		}
		exportToCSV(this.state.data, filename, this.state.typeId)
	}

	render() {
		const view = <div id="report-site">
			<div className="report-details-left"><FilterReport siteId={this.state.siteId} generate={(v) => {
				switch(parseInt(v.typeId)) {
					case 1:
						this.getFarmerRegistrationSummaryByRegionId(this.state.regionId)
					break
					case 2:
						this.getFarmerClusteringSummaryPerProvinceByRegionId(this.state.regionId)
					break
					case 3:
					break
					case 4:
					break
					case 5:
					break
					case 6:
						this.getSWGSummaryPerProvinceByRegionId(this.state.regionId)
					break
					case 7:
					break
					case 8:
				}
				this.setState({typeId: parseInt(v.typeId)})
			}} /></div>
			<div className="report-details-right">
				<ReportContent data={this.state.data} typeId={this.state.typeId} />
				<div className='reports-footer'>
					<OrgFooter eventHandler={this.handleFooterEvent}
						showSubmit={false}
						showExport={true} />
				</div>
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FilterReport extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		this.state = {
			reportType: "COLLECTIVE MARKETING",
			reportSubType: "CLUSTER MEMBERS",
			interval: "YEARLY",
			period: date.getFullYear(),
			types: [
				{id: 1, name: "REGISTERED FARMERS"},
				{id: 2, name: "CLUSTER MEMBERS"},
				{id: 4, name: "AE STEPS TRACKING"},
				{id: 6, name: "SWG MEMBERS"},
				{id: 7, name: "ORGANIZATIONS"},
				{id: 3, name: "COLLECTIVE MARKETING"},
				{id: 5, name: "COMMITMENTS"}
			],
			subTypes: [
				{id: 1, name: "CLUSTERS INVOLVED"},
				{id: 2, name: "MEMBERS INVOLVED"}
			],
			type: '-- SELECT --',
			subType: '-- SELECT --',
			disableDate: true,
			periods: getYears(),
			dateIntervals: [
				{id: 0, name: 'MONTHLY'},
				{id: 1, name: 'QUARTERLY'},
				{id: 2, name: 'SEMESTER'},
				{id: 3, name: 'YEARLY'}
			]
		}
	}

	render() {
		const view = <div className="filter-report">
			<div>Type of Report:</div>
			<DropdownWidget list={this.state.types} placeholder={this.state.type} onItemSelected={(id, val) => {
				let disable = true
				if(id == 3 || id == 5) {
					disable = false
				}
				this.setState({
					typeId: id,
					disableDate: disable,
					showTypeMSG: false
				})
			}} />
			{this.state.typeId == 3 && <DropdownWidget list={this.state.subTypes} onItemSelected={(id, val) => {
				this.setState({
					subTypeId: id,
					showTypeMSG: false
				})
			}} placeholder={this.state.subType} />}
			{this.state.showTypeMSG && <div style={{color: '#c96f6f'}}>* Select type of report</div>}
			<br />
			<div>Date:</div>
			<DropdownWidget list={this.state.dateIntervals} onItemSelected={(id, val) => {
				this.setState({
					intervalId: id,
				})
			}} placeholder={this.state.interval} disabled={this.state.disableDate} />
			<DropdownWidget list={this.state.periods} onItemSelected={(id, val) => {
				this.setState({
					period: val,
				})
			}} placeholder={this.state.period} disabled={this.state.disableDate} />
			<br />
			<button className="green-two" onClick={(k, v) => {
				if(this.state.typeId == null || (this.state.typeId == 3 && this.state.subTypeId == null)) {
					this.setState({showTypeMSG: true})
				}
				const filter = {
					typeId: this.state.typeId,
					intervalId: this.state.intervalId,
					period: this.state.period
				}
				this.props.generate(filter)
			}}>GENERATE</button>
			<button className="green-two">CLEAR</button>
		</div>
		return(view)
	}
}

class ReportContent extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			region: user.region,
			province: user.province,
			siteName: localStorage.getItem("siteName"),
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data && this.props.data != null) {
			this.setState({data: this.props.data})
			switch(parseInt(this.props.typeId)) {
				case 1:
					// var sites = []
					// this.props.data.map((item, i) => {
					// 	sites.push(<Site data={item} key={Math.random()} />)
					// })
					// console.log(sites)
					// this.setState({rfData: sites})
					break
				case 2:
					break
				case 3:
					break
				case 4:
			}
		}
	}

	render() {
		const view = <div id="report-content-site">
			{this.props.data != null && <div className="rcf-content">
				<div>
				<table className="rcf-table-one">
					<tr>
						<th>REGION</th>
					</tr>
					<tr>
						<td><div>{this.state.region}</div></td>
					</tr>
				</table>
				{this.props.typeId == 1 && <RegisteredFarmers data={this.state.data}/>}
				{this.props.typeId == 2 && <ClusterMembers data={this.state.data}/>}
				{/* {this.props.subTypeId == 1 && <ClustersInvolved data={this.state.data}/>} */}
				{/* {this.props.subTypeId == 2 && <MembersInvolved data={this.state.data}/>} */}
				{/* {this.props.typeId == 4 && <AEStepsTracking data={this.state.data}/>} */}
				{/* {this.props.typeId == 5 && <Commitments data={this.state.data}/>} */}
				{this.props.typeId == 6 && <SWGMembers data={this.state.data}/>}
				{/* {this.props.typeId == 7 && <SiteOrganizations data={this.state.data}/>} */}
			</div>
			</div>}
		</div>
		return(view)
	}
}

const RegisteredFarmers = (props) => {
	const sites = []
	if(props.data) {
		props.data.map((item, i) => {
			sites.push(<SiteRF data={item} key={Math.random()} />)
		})
	}
	return(<table className="rcf-table-two">
	<tr>
		<th colspan='11'>REGISTERED FARMERS</th>
	</tr>
	<tr>
		<th rowspan='2'>PROVINCE</th>
		<th rowspan='2'>MUNICIPALITY</th>
		<th rowspan='2'>SITE NAME</th>
		<th colspan='3'>ARBs</th>
		<th colspan='3'>NON-ARBs</th>
		<th rowspan='2'>Rural women under<br/>speical circumstances<br/>(ARB and Non-ARB)</th>
		<th rowspan='2'>TOTAL</th>
	</tr>
	<tr>
		<th>MALE</th>
		<th>FEMALE</th>
		<th>TOTAL</th>
		<th>MALE</th>
		<th>FEMALE</th>
		<th>TOTAL</th>
	</tr>
	{sites}
</table>)
}

const SiteRF = (props) => {
	return(	<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.city}</div></td>
		<td><div>{props.data?.site.toUpperCase()}</div></td>
		<td><div>{props.data?.arb_male}</div></td>
		<td><div>{props.data?.arb_female}</div></td>
		<td><div>{props.data?.total_arb}</div></td>
		<td><div>{props.data?.non_arb_male}</div></td>
		<td><div>{props.data?.non_arb_female}</div></td>
		<td><div>{props.data?.total_non_arb}</div></td>
		<td><div>{props.data?.rural_women_with_circumstance}</div></td>
		<td><div>{props.data?.total_registered}</div></td>
	</tr>)
}

const ClusterMembers = (props) => {
	const sites = []
	if(props.data) {
		props.data.map((item, i) => {
			sites.push(<SiteCM data={item} key={Math.random()} />)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='11'>TOTAL CLUSTER MEMBERS AND OFFICERS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>NUMBER OF<br/>SITES</th>
			<th rowspan='2'>NUMBER OF<br/>CLUSTERS</th>
			<th colspan='3'>ARBs</th>
			<th colspan='3'>NON-ARBs</th>
			<th rowspan='2'>Rural women under<br/>speical circumstances<br/>(ARB and Non-ARB)</th>
			<th rowspan='2'>TOTAL</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
			<th>MALE</th>
			<th>FEMALE</th>
			<th>TOTAL</th>
		</tr>
		{sites}
	</table>)
}

const SiteCM = (props) => {
	const total = parseInt(props.data?.total_arb) +
		parseInt(props.data?.total_non_arb) +
		parseInt(props.data?.rural_women_with_circumstance)
	return(	<tr>
		<td><div>{props.data?.province}</div></td>
		<td><div>{props.data?.site_count}</div></td>
		<td><div>{props.data?.cluster_count}</div></td>
		<td><div>{props.data?.arb_male}</div></td>
		<td><div>{props.data?.arb_female}</div></td>
		<td><div>{props.data?.total_arb}</div></td>
		<td><div>{props.data?.non_arb_male}</div></td>
		<td><div>{props.data?.non_arb_female}</div></td>
		<td><div>{props.data?.total_non_arb}</div></td>
		<td><div>{props.data?.rural_women_with_circumstance}</div></td>
		<td><div>{total}</div></td>
	</tr>)
}


const SWGMembers = (props) => {
	console.log('swg members', props.data)
	const items = []
	if(props.data != null) {
		props.data.map((item, i) => {
			items.push(<SiteSWG data={item}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr>
			<th colspan='6'>SITE WORKING GROUP MEMBERS</th>
		</tr>
		<tr>
			<th rowspan='2'>PROVINCE</th>
			<th rowspan='2'>SITE COUNT</th>
			<th colspan='2'>SWGs</th>
			<th rowspan='2'>IN AN<br/>ORGANIZATION</th>
			<th rowspan='2'>TOTAL</th>
		</tr>
		<tr>
			<th>MALE</th>
			<th>FEMALE</th>
		</tr>
		{items}
	</table>)
}

const SiteSWG = (props) => {
	const total = parseInt(props.data?.total) + parseInt(props.data?.in_organization)
	return(	<tr>
		<td><div>{props.data?.province.toUpperCase()}</div></td>
		<td><div>{props.data?.site_count}</div></td>
		<td><div>{props.data?.male}</div></td>
		<td><div>{props.data?.female}</div></td>
		<td><div>{props.data?.in_organization}</div></td>
		<td><div>{total}</div></td>
	</tr>)
}

const getYears = () => {
	const years = []
	const date = new Date()
	for(let i=date.getFullYear(); i>1970; i--) {
		years.push({id: i, name: i})
	}
	return years
}

const formatDate = (v) => {
	const dt = new Date(v)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m}/${d}/${dt.getFullYear()}`
	return dFormat
}

const exportToCSV = (csvData, filename, typeId) => {
	console.log(csvData, filename, typeId)
	{/* const dateObj = new Date()
	const month = dateObj.getMonth() + 1
	const dt = dateObj.getDate() - 1
	const date = month + "/" + dt + "/" + dateObj.getFullYear() */}
	const user = JSON.parse(sessionStorage.getItem("user"))
	const data = []
	data.push(["REGION"])
	data.push([user.region.replace(/\s+/g, '%20')])
	data.push([])
	switch(typeId) {
		case 1:
			data.push(["REGISTERED%20FARMERS"])
			data.push([,,"ARBs",,,"NON-ARBs"])
			data.push(["PROVINCE","MUNICIPALITY","SITE%20NAME","MALE","FEMALE","TOTAL","MALE","FEMALE","TOTAL","Rural%20women%20under%20special%20circumstances%20(ARB%20and%20Non-ARB)","TOTAL"])
			csvData.map((item, i) => {
				data.push([item.province.replace(/\s+/g, '%20'),item.city.replace(/\s+/g, '%20'),item.site.replace(/\s+/g, '%20'),item.arb_male,item.arb_female,item.total_arb,item.non_arb_male,item.non_arb_female,item.total_non_arb,item.rural_women_with_circumstance,item.total_registered])
			})
			break
		case 2:
			break
		case 3:
			break
		case 4:
			break
		case 5:
			break
		case 6:
	}
	var csvRow = [];
	for(const v of data) {
		csvRow.push(v.join(","));
	}
	var csvString = csvRow.join("%0A");
	var a = document.createElement('a');
	a.href = 'data:attachment/csv,' + csvString;
	a.target = "_Blank";
	a.download = filename + ".csv";
	a.click();
}

export default ReportSiteProvincial
